<template>
  <v-app :dark="setTheme" class="app-root" :style="!goDark ? { background: '#ffffff' } : { background: $vuetify.theme.themes[isDark].background }">
    <v-system-bar
      v-if="isDevelopmentEnv"
      app
      color="#b71c1c"
      dark
      height="24"
      class="dev-environment-banner"
    >
      <v-spacer />
      <span class="dev-environment-banner__text">{{ devEnvironmentBannerText }}</span>
      <v-spacer />
    </v-system-bar>
    <v-navigation-drawer
      v-model="drawer"
      color="sidebar"
      :class="['elevation-6', { 'white-menu-sidebar': useWhiteMenu }]"
      bottom
      :dark="!useWhiteMenu"
      app
      v-if="checkAuth() && !hide"
    >
      <!-- <v-img :src="require('@/assets/christmas.jpg')" width="60%" absolute :style="{left: '15%'}"></v-img> -->
      <!-- <v-divider></v-divider> -->

      <!-- src="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg" -->

      <v-list>
        <v-list-item class="d-flex justify-center align-center">
          <div class="logo-wrapper" style="width: 60%; max-height: 70px;">
            <v-img
              :src="logo"
              @click="$router.push('/')"
              contain
              style="cursor: pointer"
            ></v-img>
          </div>
        </v-list-item>

        <template v-for="item in items">
          <v-list-group
            v-if="item.subitems && item.subitems.length > 0"
            :key="`group-${item.title}`"
            :prepend-icon="item.icon"
            color="white"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="subItem in item.subitems"
              :key="subItem.title"
              :to="subItem.route"
              color="white"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item v-else :key="`item-${item.title}`" :to="item.route" link>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <div v-if="user.role !== 'Member'">
          <v-list-item v-show="!isElderoneClient && !isFHCContext" href="https://clearspringhealthcare.com/covered-drugs/" target="_blank">
            <v-list-item-icon>
              <v-icon>mdi-pill</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Drug Search</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-show="!isElderoneClient && !(isFHCContext && ['provider', 'specialist', 'admin', 'manager', 'affiliation'].includes(userRoleLower))" href="https://clearspringhealthcare.com/pharmacy-search/" target="_blank">
            <v-list-item-icon>
              <v-icon>mdi-mortar-pestle-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Pharmacy Search</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-show="!isElderoneClient && !(isFHCContext && ['provider', 'specialist', 'admin', 'manager', 'affiliation'].includes(userRoleLower))" href="https://clearspringhealthcare.com/plan-documents/" target="_blank">
            <v-list-item-icon>
              <v-icon>mdi-notebook-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Plan Policies</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-show="!isElderoneClient && !isFHCContext"
            href="https://clearspringhealthcare.com/wp-content/uploads/2024-Clear-Spring-Health-Provider-Manual.pdf"
            target="_blank"
          >
            <v-list-item-icon>
              <v-icon>mdi-book-information-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Provider Manual</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-show="showProviderDocumentsMenu && !(isFHCContext && ['admin','manager'].includes(userRoleLower))"
            to="/provider-documents"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-document-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Provider Documents</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
        <v-list-item
          v-if="userRoleLower === 'superuser'"
          key="BillingMember"
          to="/billing-member"
        >
          <v-list-item-icon>
            <v-icon>mdi-credit-card-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Billing Member</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="userRoleLower === 'superuser'"
          key="AdminMidpayTestCharge"
          to="/admin/midpay-test"
        >
          <v-list-item-icon>
            <v-icon>mdi-credit-card-sync</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>MidPay Test Charge</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="['superuser', 'affiliation', 'provider', 'admin', 'manager'].includes(userRoleLower)"
          key="ExplanationOfPayment"
          to="/explanation-of-payment"
        >
          <v-list-item-icon>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Payments (EOP)</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="['admin', 'superuser', 'manager'].includes(userRoleLower)"
          key="ResourcesAdmin"
          to="/resources-admin"
        >
          <v-list-item-icon>
            <v-icon>mdi-folder-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Member Documents</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="['admin', 'superuser', 'manager'].includes(userRoleLower)"
          key="Admin"
          to="/admin"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Administration</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="drawer"
      color="sidebar"
      :class="['elevation-6 rounded-right', { 'white-menu-sidebar': useWhiteMenu }]"
      bottom
      :dark="!useWhiteMenu"
      app
      v-else-if="$route.path.includes('/sharedPatient')"
    >
      <!-- <v-img :src="require('@/assets/christmas.jpg')" width="60%" absolute :style="{left: '15%'}"></v-img> -->
      <!-- <v-divider></v-divider> -->

      <!-- src="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg" -->

      <v-list>
        <v-list-item class="d-flex justify-center align-center">
          <div class="logo-wrapper" style="width: 60%; max-height: 70px;">
            <v-img :src="logo" contain></v-img>
          </div>
        </v-list-item>
        <v-list-item class="text-center"> This record has been shared by the patient </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="main-wrapper">
      <v-app-bar flat class="app-header" height="64" v-if="!hide">
        <v-btn icon class="header-btn-icon mr-1" @click.stop="drawer = !drawer" aria-label="Toggle menu">
          <v-icon>mdi-menu</v-icon>
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          v-if="enabledNotifications"
          :to="{ path: '/notifications' }"
          class="mr-2 header-btn-icon"
          icon
          variant="text"
          size="small"
        >
          <v-icon>mdi-bell</v-icon>
        </v-btn>

        <v-dialog
          v-model="openDialog"
          fullscreen
          :scrollable="false"
          :close-on-content-click="false"
        >
        </v-dialog>
        <v-menu v-model="menu" :close-on-content-click="false" location="bottom end" offset="8">
          <template v-slot:activator="{ on }">
            <div class="header-user-block d-flex align-center py-1 pl-2 pr-3" v-on="on">
              <v-avatar color="primary" size="40" class="mr-2 flex-shrink-0 header-avatar">
                <span class="white--text text-caption font-weight-medium">{{ userInitials }}</span>
              </v-avatar>
              <div class="header-user-info text-left flex-grow-0">
                <div class="text-body-2 font-weight-medium header-user-name">{{ userDisplayName }}</div>
                <div class="text-caption header-user-role">{{ userRole }}</div>
              </div>
              <v-icon size="20" class="ml-1 header-chevron">mdi-chevron-down</v-icon>
            </div>
          </template>
          <v-card>
            <v-list>
              <v-list-item>
                <v-avatar color="secondary" class="mr-2">
                  <span class="white--text">{{ userInitials }}</span>
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ userDisplayName }}</v-list-item-title>
                  <v-list-item-subtitle>{{ userRole }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>

            <!-- <v-list v-if="user.role === 'Member'">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Share Record</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn class="mx-2" fab dark small color="secondary" @click.stop="share = true">
                    <v-icon dark> mdi-email </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list> -->
            <!-- <v-divider></v-divider>
            <v-list v-if="user.role !== 'Clinical'">
              <v-list-item @click="openCustomizationModal">
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Customize</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider> -->

            <v-list v-if="showMemberContactInHeader">
              <v-list-item
                :to="{ path: '/member-contact' }"
                @click="menu = false"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon color="primary">mdi-home-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Contact information</v-list-item-title>
                  <v-list-item-subtitle class="text-caption">
                    Address &amp; phone on file
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider v-if="showMemberContactInHeader"></v-divider>

            <v-list v-if="userRoleLower === 'superuser'">
              <v-list-item>
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-tag-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-caption grey--text">Build v{{ appVersion }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider v-if="userRoleLower === 'superuser'"></v-divider>
            <v-list>
              <v-list-item>
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-weather-night</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Dark Theme</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch color="secondary" v-model="goDark" hide-details inset class></v-switch>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="secondary" text @click="logout">Log Out</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-dialog v-model="share" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Share Patient Panel</span>
            </v-card-title>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="docFirstName"
                        label="Physician first name*"
                        :rules="[(v) => !!v || 'Name is required']"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="docLastName"
                        label="Physician last name*"
                        :rules="[(v) => !!v || 'Last name is required']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="docEmail"
                        label="Email*"
                        :rules="[(v) => !!v || 'Email is required']"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-alert type="info"
                >You are about to share your medical records with your current health provider using
                the email address provided above. Please note that the shared information will only
                be visible for 30 minutes after sharing.</v-alert
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="share = false"> Close </v-btn>
                <v-btn color="blue darken-1" :loading="load" text @click="validate"> Send </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-app-bar>
      <v-snackbar v-model="snackError" :timeout="5000" :color="color">
        {{ snackMessage }}
      </v-snackbar>
      <div class="main-content-card">
        <div
          v-if="!hide && checkAuth() && userRoleLower === 'member' && memberBillingBannerVisible"
          class="member-account-status"
        >
          <v-sheet
            v-if="memberBillingAlert.bannerKind === 'account_suspended'"
            data-cy="member-banner-account-suspended"
            class="member-account-status__item member-account-status__item--danger elevation-0 mb-3"
          >
            <div class="member-account-status__inner">
              <div class="member-account-status__main">
                <v-icon class="member-account-status__icon" color="error" large>mdi-alert-octagon-outline</v-icon>
                <div class="member-account-status__text">
                  <span class="member-account-status__title">Account suspended</span>
                  <span class="member-account-status__body">
                    Your membership is suspended. Please contact member services for assistance.
                  </span>
                </div>
              </div>
              <div class="member-account-status__actions">
                <v-btn
                  :to="{ path: '/member-payments' }"
                  color="primary"
                  depressed
                  class="member-account-status__cta"
                  data-cy="member-banner-payments-cta"
                >
                  <v-icon left small class="mr-1">mdi-credit-card-outline</v-icon>
                  My payments
                </v-btn>
              </div>
            </div>
          </v-sheet>
          <v-sheet
            v-else-if="memberBillingAlert.bannerKind === 'plan_suspended_nonpay'"
            data-cy="member-banner-plan-suspended-nonpay"
            class="member-account-status__item member-account-status__item--danger elevation-0 mb-3"
          >
            <div class="member-account-status__inner">
              <div class="member-account-status__main">
                <v-icon class="member-account-status__icon" color="error" large>mdi-cancel</v-icon>
                <div class="member-account-status__text">
                  <span class="member-account-status__title">Plan suspended</span>
                  <span class="member-account-status__body">
                    Your plan has been suspended. Pay your balance in My Payments to restore coverage, or contact member services.
                  </span>
                </div>
              </div>
              <div class="member-account-status__actions">
                <v-btn
                  :to="{ path: '/member-payments' }"
                  color="primary"
                  depressed
                  class="member-account-status__cta"
                  data-cy="member-banner-payments-cta-suspended-nonpay"
                >
                  <v-icon left small class="mr-1">mdi-credit-card-outline</v-icon>
                  Pay now — My payments
                </v-btn>
              </div>
            </div>
          </v-sheet>
          <v-sheet
            v-else-if="memberBillingAlert.bannerKind === 'payment_grace'"
            data-cy="member-banner-payment-grace"
            class="member-account-status__item member-account-status__item--warning elevation-0 mb-3"
          >
            <div class="member-account-status__inner">
              <div class="member-account-status__main">
                <v-icon class="member-account-status__icon" color="warning" large>mdi-calendar-clock</v-icon>
                <div class="member-account-status__text">
                  <span class="member-account-status__title">Payment past due</span>
                  <span class="member-account-status__body">
                    Your premium is overdue. Your plan is still active. Please pay as soon as possible in My Payments.
                  </span>
                </div>
              </div>
              <div class="member-account-status__actions">
                <v-btn
                  :to="{ path: '/member-payments' }"
                  color="primary"
                  depressed
                  class="member-account-status__cta"
                  data-cy="member-banner-payments-cta-grace"
                >
                  <v-icon left small class="mr-1">mdi-credit-card-outline</v-icon>
                  Pay now — My payments
                </v-btn>
              </div>
            </div>
          </v-sheet>
        </div>
        <router-view></router-view>
      </div>
    </v-main>
    <v-footer padless>
      <v-card tile class="text-center elevation-3" width="100%">
        <v-card-text class="accent--text">
          <div
            v-if="userRoleLower === 'member'"
            class="member-plan-change-notice caption grey--text text--darken-1 mb-2"
          >
            Changes to your plan, including upgrades, can't be made through this
            portal. Please contact member services for assistance, we're happy to
            help!
          </div>
          © {{ new Date().getFullYear() }} —
          <strong>HALOS Systems</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import axios from 'axios';
import Mixin from './utils/Mixin';

export default {
  name: 'App',
  mixins: [Mixin],
  data: () => ({
    menu: false,
    goDark: false,
    openDialog: false,
    drawer: true,
    globalSearch: '',
    user: '',
    share: false,
    snackError: false,
    color: '',
    load: false,
    snackMessage: '',
    docFirstName: '',
    docLastName: '',
    docEmail: '',
    valid: false,
    render: true,
    userAuth: false,
    opts: {
      theme: {
        dark: false,
      },
    },
    items: [],
    memberBillingAlert: {
      bannerKind: 'none',
      overdueDays: 0,
      daysUntilPlanSuspension: 0,
    },
    serverAppEnvironment: null,
  }),
  mounted() {
    this.fetchAppEnvironment();
    this.getUser();
    this.$root.$on('refresh-member-billing-alert', this.loadMemberBillingAlert);
    console.log('Made with ❤️ by Halos');
    // load theme
    if (localStorage.darkMode) {
      this.goDark = JSON.parse(localStorage.getItem('darkMode' || '[]'));
    }

    // set menu size
    if (this.$vuetify.breakpoint.smAndDown) {
      this.drawer = false;
    } else {
      this.drawer = true;
    }
    // this.setDefaultDashboard();
  },

  beforeDestroy() {
    this.$root.$off('refresh-member-billing-alert', this.loadMemberBillingAlert);
  },

  methods: {
    fetchAppEnvironment() {
      if (process.env.NODE_ENV !== 'development') return;
      axios
        .get('/api/app-environment')
        .then((res) => {
          this.serverAppEnvironment = res.data || null;
        })
        .catch(() => {
          this.serverAppEnvironment = null;
        });
    },
    getUser() {
      if (!this.$route.path.includes('sharedPatient')) {
        return axios
          .get('/api/user')
          .then((response) => {
            if (response.data && response.data.length > 0) {
              this.user = response.data[0];
              this.userAuth = true;
              this.loadMemberBillingAlert();
              return response.data[0];
            } else {
              console.warn('⚠️ getUser: No user data in response');
              this.userAuth = false;
              this.resetMemberBillingAlert();
              // Only redirect if we're not already on login or pwchange pages
              if (!this.$route.path.includes('pwchange') && this.$route.path !== '/login') {
                console.log('🔄 Redirecting to login - no user data');
                this.$router.push('/login');
              }
              return null;
            }
          })
          .catch((error) => {
            const status = error.response && error.response.status;
            const errorData = error.response && error.response.data;
            console.error('❌ getUser error:', status, errorData || error.message);
            // Don't redirect on 401 if we're already on login page (to avoid redirect loop)
            if (status === 401) {
              console.log('🔐 401 Unauthorized - user not authenticated');
              this.userAuth = false;
              this.user = '';
              this.resetMemberBillingAlert();
              // Only redirect if not already on login/pwchange
              if (!this.$route.path.includes('pwchange') && this.$route.path !== '/login') {
                console.log('🔄 Redirecting to login - 401 error');
                this.$router.push('/login');
              }
            } else {
              // For other errors, still redirect if not on login/pwchange
              this.userAuth = false;
              this.user = '';
              this.resetMemberBillingAlert();
              if (!this.$route.path.includes('pwchange') && this.$route.path !== '/login') {
                console.log('🔄 Redirecting to login - other error');
                this.$router.push('/login');
              }
            }
            return null;
          });
      }
      return Promise.resolve(null);
    },
    resetMemberBillingAlert() {
      this.memberBillingAlert = {
        bannerKind: 'none',
        overdueDays: 0,
        daysUntilPlanSuspension: 0,
      };
    },
    loadMemberBillingAlert() {
      const role = (this.user && this.user.role && String(this.user.role).toLowerCase()) || '';
      if (!this.checkAuth() || role !== 'member') {
        this.resetMemberBillingAlert();
        return;
      }
      axios
        .get('/api/enrollment/member-billing-alert')
        .then((res) => {
          if (res.data && res.data.success) {
            this.memberBillingAlert = {
              bannerKind: res.data.bannerKind || 'none',
              overdueDays: Number(res.data.overdueDays) || 0,
              daysUntilPlanSuspension: Number(res.data.daysUntilPlanSuspension) || 0,
            };
          }
        })
        .catch(() => {});
    },
    // validate(selectedTopChart, selectedMiddleCards, selectedBottomCharts) {
    //   if (this.$refs.form.validate()) {
    //     this.saveCharts(selectedTopChart, selectedMiddleCards, selectedBottomCharts);
    //   }
    // },
    checkAuth() {
      return this.userAuth;
    },
    validate(e) {
      // Validate that data is correct before submitting
      if (this.$refs.form.validate()) {
        this.sharePatient();
      }
    },
    handleClick(item) {
      if (typeof item.action === 'function') {
        item.action();
      } else if (item.action) {
        this.share = true;
      } else if (item.route) {
        this.$router.push(item.route);
      }
    },
    openModal() {
      this.showModal = true;
    },
    sharePatient() {
      this.load = true;
      axios
        .post('/api/sharedpatient/share', {
          insurance: this.user.insurance[0],
          memberId: this.user.memberId,
          birthDate: this.user.birthDate,
          doctorFirstName: this.docFirstName,
          doctorLastName: this.docLastName,
          email: this.docEmail,
        })
        .then(() => {
          this.share = false;
          this.load = false;
          this.color = 'success';
          this.snackError = true;
          this.snackMessage = 'Successfully shared records with physician.';
        })
        .catch(() => {
          this.load = false;
          // display snackbar notification
          this.share = false;
          this.color = 'error';
          this.snackError = true;
          this.snackMessage = 'This record has already been shared.';
        });
    },
    logout() {
      this.user = '';
      this.resetMemberBillingAlert();
      axios.get('/api/logout').then(() => {
        this.$router.push('/login');
      });
    },
    upperCase(str) {
      const array1 = str.split(' ');
      const newarray1 = [];
      for (let x = 0; x < array1.length; x++) {
        newarray1.push(array1[x].charAt(0).toUpperCase() + array1[x].slice(1));
      }
      return newarray1.join(' ');
    },
    onGlobalSearch() {
      const q = (this.globalSearch || '').trim();
      if (q && this.$route.path !== '/patients') {
        this.$router.push({ path: '/patients', query: { search: q } });
      } else if (q && this.$route.path === '/patients') {
        this.$emit('global-search', q);
      }
    },
  },

  computed: {
    isDevelopmentEnv() {
      return process.env.NODE_ENV === 'development';
    },
    devEnvironmentBannerText() {
      const s = this.serverAppEnvironment;
      if (!s) return 'Development';
      const usesProductionData =
        s.likelyProductionCluster === true || s.serverProduction === true;
      if (usesProductionData) {
        const db = s.mongoDbName ? ` · ${s.mongoDbName}` : '';
        return `Local dev · Production data${db}`;
      }
      return 'Development';
    },
    setTheme() {
      if (this.goDark == true) {
        return (this.$vuetify.theme.dark = true);
      }
      return (this.$vuetify.theme.dark = false);
    },
    useWhiteMenu() {
      return process.env.VUE_APP_WHITE_MENU === 'true';
    },
    hide() {
      return (
        this.$route.path === '/login' ||
        this.$route.path.includes('/pwchange') ||
        this.$route.path.includes('/sharedPatient')
      );
    },
    isDark() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
    enabledNotifications() {
      if (this.user && this.user.notifications === true) {
        return true;
      }
      return false;
    },
    userInitials() {
      if (!this.user || this.user === '') return 'U';
      const str = this.user.username || this.user.email || 'U';
      return String(str)
        .split(' ')
        .map((n) => (n && n[0]) ? n[0].toUpperCase() : '')
        .join('')
        .substring(0, 2);
    },
    userDisplayName() {
      if (!this.user || this.user === '') return 'User';
      return this.upperCase(this.user.username || this.user.email || 'User');
    },
    appVersion() {
      return process.env.VUE_APP_VERSION || '?';
    },
    userRole() {
      if (!this.user || this.user === '') return '';
      const r = this.user.role || '';
      return r.charAt(0).toUpperCase() + r.slice(1).toLowerCase();
    },
    userRoleLower() {
      return (this.user && this.user.role && String(this.user.role).toLowerCase()) || '';
    },
    isElderoneClient() {
      return process.env.VUE_APP_CUSTOMER === 'Elderone';
    },
    isFamilyHealthChoiceClient() {
      // Verifica se o usuário pertence ao plano FamilyHealthChoice (ou Florida no mesmo portal)
      if (this.user && this.user.insurance && Array.isArray(this.user.insurance)) {
        return this.user.insurance.some((ins) => {
          const s = String(ins || '')
            .replace(/\s+/g, '')
            .toLowerCase();
          return s === 'familyhealthchoice' || s === 'floridahealthchoice';
        });
      }
      return false;
    },
    // Portal/tenant é FHC (VUE_APP_CUSTOMER). Admin/manager podem não ter user.insurance; assim o menu FHC é aplicado.
    // Aceita FamilyhealthChoice e FloridaHealthChoice (sem espaço no valor).
    isFamilyHealthChoiceTenant() {
      const c = (process.env.VUE_APP_CUSTOMER || '').toLowerCase();
      return c === 'familyhealthchoice' || c === 'floridahealthchoice';
    },
    // FHC por usuário OU por tenant — usado para esconder menus para admin/manager no portal FHC
    isFHCContext() {
      return this.isFamilyHealthChoiceClient || this.isFamilyHealthChoiceTenant;
    },
    isFloridaHealthChoiceClient() {
      if (this.user && this.user.insurance && Array.isArray(this.user.insurance)) {
        return this.user.insurance.some((ins) => {
          const s = String(ins || '')
            .replace(/\s+/g, '')
            .toLowerCase();
          return s === 'floridahealthchoice';
        });
      }
      return false;
    },
    /** Menu de membro FHC (enrollment, Finlay, etc.): por insurance no user ou tenant do build */
    isFhcMemberMenuEligible() {
      return (
        this.isFamilyHealthChoiceClient ||
        this.isFloridaHealthChoiceClient ||
        this.isFamilyHealthChoiceTenant
      );
    },
    // Provider Documents: Superuser, Admin e Manager veem sempre; Provider/Specialist só quando FamilyHealthChoice
    showProviderDocumentsMenu() {
      if (!this.userRoleLower) return false;
      if (['superuser', 'admin', 'manager'].includes(this.userRoleLower)) return true;
      if ((this.userRoleLower === 'provider' || this.userRoleLower === 'specialist') && this.isFamilyHealthChoiceClient) return true;
      return false;
    },
    memberBillingBannerVisible() {
      return this.memberBillingAlert.bannerKind !== 'none';
    },
    showMemberContactInHeader() {
      if (this.userRoleLower !== 'member') return false;
      return this.isFhcMemberMenuEligible;
    },
  },

  watch: {
    hide() {
      this.getUser();
    },
    '$route.fullPath'() {
      if (this.hide || !this.checkAuth() || this.userRoleLower !== 'member') return;
      this.loadMemberBillingAlert();
    },
    '$route': {
      handler(to, from) {
        // Recarregar dados do usuário quando a rota mudar (especialmente após login)
        // NÃO fazer isso se estiver acessando a raiz sem estar autenticado
        if (to.path === '/' && !localStorage.getItem('user')) {
          // Se estiver na raiz sem autenticação, o router guard já vai redirecionar
          return;
        }

        if (to.path !== '/login' && to.path !== '/pwchange' && (!from || to.path !== from.path)) {
          // Pequeno delay para garantir que a sessão foi estabelecida
          setTimeout(() => {
            this.getUser().then(() => {
              // Se for FamilyHealthChoice com role Member, redirecionar para /member-enrollment
              // EXCETO se estiver indo para /member-payments, /member-cards, /easy-drug-card, /resources, /providers ou se estiver na raiz
              if (this.user && this.userRoleLower === 'member' && this.isFamilyHealthChoiceClient) {
                if (to.path !== '/member-enrollment' && to.path !== '/member-contact' && to.path !== '/member-payments' && to.path !== '/member-cards' && to.path !== '/easy-drug-card' && to.path !== '/resources' && to.path !== '/my-documents' && to.path !== '/finlay-lab' && to.path !== '/providers' && to.path !== '/') {
                  this.$router.push('/member-enrollment');
                }
              }
            });
          }, 100);
        }
      },
      immediate: false
    },
    async goDark() {
      localStorage.setItem('darkMode', JSON.stringify(this.goDark));
    },
    async user() {
      // Verificar se user existe e tem role antes de construir menu
      if (!this.user || !this.user.role) {
        console.log('⚠️ User ou role não definido');
        return;
      }

      console.log('👤 Construindo menu para:', this.user.role);
      console.log('🏥 Insurance:', this.user.insurance);
      console.log('🔍 isFamilyHealthChoiceClient:', this.isFamilyHealthChoiceClient);
      console.log('🔍 isFloridaHealthChoiceClient:', this.isFloridaHealthChoiceClient);

      // IMPORTANTE: Verificar roles Admin, Manager e Superuser ANTES de verificar FamilyHealthChoice
      // para garantir que eles sempre tenham seus menus completos
      // Normalizar role para comparação case-insensitive
      const userRole = (this.user.role || '').toLowerCase();

      if (userRole === 'admin' || userRole === 'manager') {
        // Para FHC (tenant ou user.insurance): remover Claims Search, Finance, Utilization, Authorizations, Coding & Quality; Membership permanece para admin/manager
        const isFHC = this.isFHCContext;
        this.items = [
          {
            name: 'Dashboard',
            title: 'Dashboard',
            icon: 'mdi-view-dashboard',
            route: '/',
            subitems: [],
            props: true,
          },
          {
            title: 'Patient Search',
            icon: 'mdi-book-search',
            route: userRole === 'manager' ? '/patient-lookup' : '/patients',
            subitems: [],
          },
          {
            title: 'Provider Search',
            icon: 'mdi-doctor',
            route: '/providers',
            subitems: [],
          },
          ...(isFHC ? [] : [{
            title: 'Claims Search',
            icon: 'file-search',
            route: '/claims',
            subitems: [],
          }]),
          ...(isFHC ? [] : [{
            title: 'Finance',
            icon: 'mdi-finance',
            route: '/',
            subitems: [
              { title: 'KPIs', icon: 'mdi-elevation-rise', route: '/kpis', subitems: [] },
              { title: 'Finance Reports', icon: 'mdi-finance', route: '/finance', subitems: [] },
              { title: 'Contract Comparison', icon: 'mdi-elevation-decline', route: '/contract', subitems: [] },
            ],
          }]),
          ...(isFHC ? [] : [{
            title: 'Utilization',
            icon: 'mdi-chart-bar',
            route: '/utilization',
            subitems: [],
          }]),
          ...(isFHC ? [] : [{
            title: 'Authorizations',
            icon: 'mdi-fax',
            route: '/authorizations',
            subitems: [],
          }]),
          {
            title: 'Membership',
            icon: 'mdi-account-group',
            route: '/membership',
            subitems: [],
          },
          ...(isFHC ? [] : [{
            title: 'Coding & Quality',
            icon: 'mdi-code-brackets',
            route: '/',
            subitems: [
              { title: 'Coding', icon: 'mdi-code-brackets', route: '/coding', subitems: [] },
              { title: 'Quality', icon: 'mdi-medical-bag', route: '/quality', subitems: [] },
            ],
          }]),
          ...(isFHC ? [] : [{
            title: 'Tasks',
            icon: 'mdi-notebook-check',
            route: '/tasks',
            subitems: [],
          }]),
          ...(isFHC ? [] : (process.env.VUE_APP_CUSTOMER !== 'Elderone' ? [{
            title: 'Care Plans',
            icon: 'mdi-notebook',
            route: '/careplans',
            subitems: [],
          }] : [])),
          // Provider Documents: em FHC para admin/manager incluir no menu dinâmico para garantir visibilidade
          ...(isFHC ? [{
            title: 'Provider Documents',
            icon: 'mdi-file-document-multiple',
            route: '/provider-documents',
            subitems: [],
          }, {
            title: 'Finlay Lab',
            icon: 'mdi-flask-outline',
            route: '/finlay-lab',
            subitems: [],
          }] : []),
        ];
      } else if (userRole === 'superuser') {
        console.log('✅ Criando menu para Superuser');
        this.items = [
          {
            name: 'Dashboard',
            title: 'Dashboard',
            icon: 'mdi-view-dashboard',
            route: '/',
            subitems: [],
            props: true,
          },
          {
            title: 'Patient Search',
            icon: 'mdi-book-search',
            route: '/patients',
            subitems: [],
          },
          {
            title: 'Provider Search',
            icon: 'mdi-doctor',
            route: '/providers',
            subitems: [],
          },
          ...(this.isFamilyHealthChoiceClient ? [] : [{
            title: 'Claims Search',
            icon: 'file-search',
            route: '/claims',
            subitems: [],
          }]),
          {
            title: 'Claims Management',
            icon: 'mdi-file-document-plus',
            route: '/claims-management',
            subitems: [],
          },
          {
            title: 'Finance',
            icon: 'mdi-finance',
            route: '/',
            subitems: [
              {
                title: 'KPIs',
                icon: 'mdi-chart-line',
                route: '/kpis',
                subitems: [],
              },
              {
                title: 'Finance',
                icon: 'mdi-finance',
                route: '/finance',
                subitems: [],
              },
              {
                title: 'Contract',
                icon: 'mdi-file-document',
                route: '/contract',
                subitems: [],
              },
            ],
          },
          // Remove Utilization for FamilyHealthChoice
          ...(this.isFamilyHealthChoiceClient ? [] : [{
            title: 'Utilization',
            icon: 'mdi-chart-bar',
            route: '/utilization',
            subitems: [],
          }]),
          {
            title: 'Membership',
            icon: 'mdi-account-group',
            route: '/membership',
            subitems: [],
          },
          // Alinhar com Admin/Manager: Coding só fora do contexto FHC; em FHC mantém só Quality
          ...(this.isFHCContext ? [{
            title: 'Quality',
            icon: 'mdi-medical-bag',
            route: '/quality',
            subitems: [],
          }] : [{
            title: 'Coding & Quality',
            icon: 'mdi-code-brackets',
            route: '/',
            subitems: [
              { title: 'Coding', icon: 'mdi-code-brackets', route: '/coding', subitems: [] },
              { title: 'Quality', icon: 'mdi-medical-bag', route: '/quality', subitems: [] },
            ],
          }]),
          {
            title: 'RAPS',
            icon: 'mdi-file-document-multiple',
            route: '/raps',
            subitems: [
              {
                title: 'Manage RAPS',
                route: '/raps',
              },
              {
                title: 'Analyze External Files',
                route: '/raps/analyze-external',
              },
            ],
          },
          {
            title: 'Member Documents',
            icon: 'mdi-folder-cog',
            route: '/resources-admin',
            subitems: [],
          },
          ...(this.isFHCContext ? [{
            title: 'Finlay Lab',
            icon: 'mdi-flask-outline',
            route: '/finlay-lab',
            subitems: [],
          }] : []),
        ];
        console.log('📋 Superuser items criados:', this.items.length, 'itens');
      } else if (userRole === 'group' || userRole === 'affiliation') {
        this.items = [
          {
            title: 'Dashboard',
            icon: 'mdi-view-dashboard',
            route: '/',
            subitems: [],
          },
          {
            title: 'Patient Search',
            icon: 'mdi-book-search',
            route: '/patient-lookup',
            subitems: [],
          },
          {
            title: 'Provider Search',
            icon: 'mdi-doctor',
            route: '/providers',
            subitems: [],
          },
          ...(this.isFamilyHealthChoiceClient ? [] : [{
            title: 'Claims Search',
            icon: 'file-search',
            route: '/claims',
            subitems: [],
          }]),
          // Remove Utilization for FamilyHealthChoice
          ...(this.isFamilyHealthChoiceClient ? [] : [{
            title: 'Utilization',
            icon: 'mdi-chart-bar',
            route: '/utilization',
            subitems: [],
          }]),
          {
            title: 'Membership',
            icon: 'mdi-account-group',
            route: '/membership',
            subitems: [],
          },
          // Remove Coding & Quality for FamilyHealthChoice
          ...(this.isFamilyHealthChoiceClient ? [] : [{
            title: 'Coding & Quality',
            icon: 'mdi-code-brackets',
            route: '/',
            subitems: [
              {
                title: 'Coding',
                icon: 'mdi-code-brackets',
                route: '/coding',
                subitems: [],
              },
              {
                title: 'Quality',
                icon: 'mdi-medical-bag',
                route: '/quality',
                subitems: [],
              },
            ],
          }]),
        ];
      } else if (userRole === 'provider' || userRole === 'specialist') {
        // Menu base para Provider
        const baseMenu = [
          {
            title: 'Dashboard',
            icon: 'mdi-view-dashboard',
            route: '/',
            subitems: [],
          },
        ];

        // Itens exclusivos para FamilyHealthChoice (tenant ou user.insurance)
        const fhcOnlyItems = this.isFHCContext ? [
          {
            title: 'Patient Search',
            icon: 'mdi-book-search',
            route: '/patient-lookup',
            subitems: [],
          },
          {
            title: 'Provider Search',
            icon: 'mdi-doctor',
            route: '/providers',
            subitems: [],
          },
          {
            title: 'Provider Details',
            icon: 'mdi-stethoscope',
            route: '/provider-details',
            subitems: [],
          },
        ] : [];

        // Membership - Provider e Specialist têm acesso a Members em todos os clientes
        const membershipMenu = [
          {
            title: 'Membership',
            icon: 'mdi-account-group',
            route: '/membership',
            subitems: [],
          },
        ];

        // Itens removidos para FamilyHealthChoice (mantidos para outros clientes)
        const restrictedItemsForFHC = this.isFamilyHealthChoiceClient ? [] : [
          {
            title: 'Claims Search',
            icon: 'mdi-file-search',
            route: '/claims',
          },
          // Remover Authorizations para FamilyHealthChoice
          ...(this.isFamilyHealthChoiceClient ? [] : [{
            title: 'Authorizations',
            icon: 'mdi-fax',
            route: '/authorizations',
            subitems: [],
          }]),
          {
            title: 'Utilization',
            icon: 'mdi-chart-bar',
            route: '/utilization',
            subitems: [],
          },
          {
            title: 'Coding & Quality',
            icon: 'mdi-code-brackets',
            route: '/',
            subitems: [
              {
                title: 'Coding',
                icon: 'mdi-code-brackets',
                route: '/coding',
                subitems: [],
              },
              {
                title: 'Quality',
                icon: 'mdi-medical-bag',
                route: '/quality',
                subitems: [],
              },
            ],
          },
        ];

        this.items = [...baseMenu, ...fhcOnlyItems, ...membershipMenu, ...restrictedItemsForFHC];
      } else if (userRole === 'member') {
        // Para FamilyHealthChoice/FloridaHealthChoice Members, mostrar apenas Member Enrollment e Payments
        if (this.isFhcMemberMenuEligible) {
          console.log('✅ Criando menu para FamilyHealthChoice Member');
          this.items = [
            {
              title: 'Member Enrollment',
              icon: 'mdi-account-check',
              route: '/member-enrollment',
              subitems: [],
            },
            {
              title: 'Provider Search',
              icon: 'mdi-doctor',
              route: '/providers',
              subitems: [],
            },
            {
              title: 'Payments',
              icon: 'mdi-cash-multiple',
              route: '/member-payments',
              subitems: [],
            },
            {
              title: 'Member ID Card',
              icon: 'mdi-card-account-details',
              route: '/member-cards',
              subitems: [],
            },
            {
              title: 'Easy Drug Card',
              icon: 'mdi-pill',
              route: '/easy-drug-card',
              subitems: [],
            },
            {
              title: 'Resources',
              icon: 'mdi-folder-download',
              route: '/resources',
              subitems: [],
            },
            {
              title: 'My Documents',
              icon: 'mdi-file-document-multiple',
              route: '/my-documents',
              subitems: [],
            },
            {
              title: 'Finlay Lab',
              icon: 'mdi-flask-outline',
              route: '/finlay-lab',
              subitems: [],
            },
          ];
          console.log('📋 Items criados:', this.items);
          return; // Retornar para não executar o código abaixo
        }
        // Para outros Members (não FamilyHealthChoice), usar menu padrão
        // Para FloridaHealthChoice, já foi tratado acima, não entrar aqui
        if (this.isFloridaHealthChoiceClient) {
          // Já foi definido acima
          return;
        }

        this.items = [
            // Remover Member Information para FamilyHealthChoice
            ...(this.isFamilyHealthChoiceClient ? [] : [{
              title: 'Member Information',
              icon: 'mdi-chart-bar',
              route: '/member',
              subitems: [],
            }]),
            // Remover Find Providers para FamilyHealthChoice
            ...(this.isFamilyHealthChoiceClient ? [] : [{
              title: 'Find Providers',
              icon: 'mdi-map-marker',
              route: '/map',
              subitems: [],
            }]),
            // Remover Provider Search Map para FamilyHealthChoice
            ...(this.isFamilyHealthChoiceClient ? [] : [{
              title: 'Provider Search Map',
              icon: 'mdi-map-search',
              route: '/providers-map',
              subitems: [],
            }]),
            {
              title: 'Member Enrollment',
              icon: 'mdi-account-check',
              route: '/member-enrollment',
              subitems: [],
            },
            // Remover Authorizations para FamilyHealthChoice
            ...(this.isFamilyHealthChoiceClient ? [] : [{
              title: 'Authorizations',
              icon: 'mdi-fax',
              route: '/authorizations',
              subitems: [],
            }]),
            // Remover Share Record para FamilyHealthChoice
            ...(this.isFamilyHealthChoiceClient ? [] : [{
              title: 'Share Record',
              icon: 'mdi-share',
              action: 'openModal',
              subitems: [],
            }]),
            // Remover Contact Us para FamilyHealthChoice e Elderone
            ...(this.isElderoneClient || this.isFamilyHealthChoiceClient ? [] : [{
              title: 'Contact Us',
              icon: 'mdi-account-question',
              action: () => {
                window.open('https://clearspringhealthcare.com/contact-us/', '_blank', 'noopener');
              },
              subitems: [],
            }]),
            // Remover Milliman Guidelines para FamilyHealthChoice e Elderone
            ...(this.isElderoneClient || this.isFamilyHealthChoiceClient ? [] : [{
              title: 'Milliman Guidelines',
              icon: 'mdi-book-information-variant',
              action: () => {
                window.open('https://clearspring.access.mcg.com/index', '_blank', 'noopener');
              },
              subitems: [],
            }]),
          ];

        // Remover OptumRX Records para FamilyHealthChoice e FloridaHealthChoice
        if (!this.isFhcMemberMenuEligible) {
          this.items.push({
            title: 'OptumRX Records',
            icon: 'mdi-book-information-variant',
            action: () => {
              window.open('/api/saml/login/'+this.user.memberId, '_blank', 'noopener');
            },
            subitems: [],
          });
        }
      }
      // Claim Processing - apenas para Elderone, excluir Provider/Specialist do FamilyHealthChoice
      // Também excluir completamente para FamilyHealthChoice
      if (process.env.VUE_APP_CUSTOMER === 'Elderone' && !this.isFamilyHealthChoiceClient) {
        const isProviderOrSpecialist = this.userRoleLower === 'provider' || this.userRoleLower === 'specialist';
        const shouldExclude = isProviderOrSpecialist && this.isFamilyHealthChoiceClient;

        if (!shouldExclude) {
          this.items.push({
            title: 'Claim Processing',
            icon: 'mdi-file-document-edit-outline',
            action: () => {
              window.open('https://qcdemo.quickcap.net/DEMO/general/index.php', '_blank', 'noopener');
            },
            subitems: [],
          });
        }
      }

      // Billing Information - excluir para Provider/Specialist/Affiliation do FamilyHealthChoice
      if (this.userRoleLower === 'provider' || this.userRoleLower === 'affiliation') {
        const isProviderOrSpecialist = this.userRoleLower === 'provider' || this.userRoleLower === 'specialist';
        const shouldExclude = this.isFamilyHealthChoiceClient && (isProviderOrSpecialist || this.userRoleLower === 'affiliation');

        if (!shouldExclude) {
          this.items.push({
            title: 'Billing information',
            icon: 'mdi-book-information-variant',
            route: '/billing-information',
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/sass/variables.scss'; // Import the variables.scss file here

#app {
  font-family: 'Nunito', Montserrat, sans-serif; /* font for entire app */
}

/* Layout inspirado em referência: fundo azul claro + card branco */
.main-wrapper {
  background: #ffffff !important;
  min-height: 100vh;
}
.v-application.theme--dark .main-wrapper {
  background: #1a1d21 !important;
}

.main-content-card {
  flex: 1;
  margin: 0;
  padding: 6px 10px;
  background: transparent;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  min-height: calc(100vh - 64px - 48px - 52px);
}
.main-content-card .v-container {
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  max-width: 100%;
}
.main-content-card .v-row {
  margin-left: -6px !important;
  margin-right: -6px !important;
}
.main-content-card .v-row > .v-col,
.main-content-card .v-row > [class*="col-"] {
  padding: 6px !important;
}

/* Estilo único para títulos de página - cor de destaque (teal) */
.main-content-card .page-title,
.main-content-card .app-page-title {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  color: #007d82 !important;
  margin-bottom: 0.5rem !important;
  line-height: 1.3 !important;
}
.main-content-card .page-subtitle {
  font-size: 0.875rem !important;
  color: #5a6c7d !important;
  margin-bottom: 1rem !important;
}
.v-application.theme--dark .main-content-card .page-title,
.v-application.theme--dark .main-content-card .app-page-title {
  color: #00ADB5 !important;
}
.v-application.theme--dark .main-content-card .page-subtitle {
  color: #a0aec0 !important;
}

.v-application.theme--dark .main-content-card {
  background: transparent;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Member billing / account status — high-visibility notice above page content */
.member-account-status {
  max-width: 1280px;
  margin: 0 auto;
  padding: 8px 4px 0;
}
.member-account-status__item {
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.07),
    0 0 0 1px rgba(0, 0, 0, 0.03);
}
.v-application.theme--dark .member-account-status__item {
  border-color: rgba(255, 255, 255, 0.18);
  box-shadow:
    0 2px 12px rgba(0, 0, 0, 0.35),
    0 0 0 1px rgba(255, 255, 255, 0.06);
}
.member-account-status__item--danger {
  border-left: 6px solid #c62828;
  background: linear-gradient(90deg, rgba(229, 57, 53, 0.14) 0%, rgba(229, 57, 53, 0.06) 100%);
  border-color: rgba(198, 40, 40, 0.35);
}
.v-application.theme--dark .member-account-status__item--danger {
  background: linear-gradient(90deg, rgba(229, 57, 53, 0.28) 0%, rgba(229, 57, 53, 0.1) 100%);
  border-color: rgba(239, 83, 80, 0.45);
}
.member-account-status__item--warning {
  border-left: 6px solid #ef6c00;
  background: linear-gradient(90deg, rgba(251, 140, 0, 0.2) 0%, rgba(251, 140, 0, 0.08) 100%);
  border-color: rgba(239, 108, 0, 0.35);
}
.v-application.theme--dark .member-account-status__item--warning {
  background: linear-gradient(90deg, rgba(251, 140, 0, 0.25) 0%, rgba(251, 140, 0, 0.1) 100%);
  border-color: rgba(255, 167, 38, 0.4);
}
.member-account-status__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 14px 16px;
  padding: 16px 18px;
}
.member-account-status__main {
  display: flex;
  align-items: flex-start;
  flex: 1 1 260px;
  min-width: 0;
  gap: 14px;
}
.member-account-status__icon {
  flex-shrink: 0;
  margin-top: 2px;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.08));
}
.member-account-status__text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.member-account-status__title {
  font-weight: 700;
  font-size: 1.0625rem;
  line-height: 1.35;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.92);
}
.v-application.theme--dark .member-account-status__title {
  color: rgba(255, 255, 255, 0.98);
}
.member-account-status__body {
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.72);
}
.v-application.theme--dark .member-account-status__body {
  color: rgba(255, 255, 255, 0.78);
}
.member-account-status__actions {
  flex-shrink: 0;
}
.member-account-status__cta.v-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 0 18px !important;
  height: 40px !important;
  box-shadow: 0 2px 6px rgba(0, 125, 130, 0.35) !important;
}
.v-application.theme--dark .member-account-status__cta.v-btn {
  box-shadow: 0 2px 8px rgba(0, 173, 181, 0.25) !important;
}

/* Header - branco, limpo, sombra suave (como na referência) */
.app-header {
  background: #ffffff !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}
.app-header .header-btn-icon .v-icon {
  color: #4a5568 !important;
}
.app-header .header-user-name {
  color: #2d3748 !important;
}
.app-header .header-user-role,
.app-header .header-chevron {
  color: #718096 !important;
}
.app-header .global-search-field .v-input__control,
.app-header .global-search-field .v-field,
.app-header .global-search-field .v-input__slot {
  background: #f5f6f8 !important;
  border: none !important;
  border-radius: 12px !important;
  color: #2d3748 !important;
}
.app-header .global-search-field .v-field::before,
.app-header .global-search-field .v-field::after {
  display: none !important;
}
.app-header .global-search-field input::placeholder {
  color: #a0aec0;
}
.global-search-field {
  flex: 0 1 auto;
}

/* Dark theme - header */
.v-application.theme--dark .app-header {
  background: #25282c !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
}
.v-application.theme--dark .app-header .header-btn-icon .v-icon {
  color: #e2e8f0 !important;
}
.v-application.theme--dark .app-header .header-user-name {
  color: #e2e8f0 !important;
}
.v-application.theme--dark .app-header .header-user-role,
.v-application.theme--dark .app-header .header-chevron {
  color: #a0aec0 !important;
}
.v-application.theme--dark .app-header .global-search-field .v-input__control,
.v-application.theme--dark .app-header .global-search-field .v-field,
.v-application.theme--dark .app-header .global-search-field .v-input__slot {
  background: rgba(255, 255, 255, 0.06) !important;
  color: #e2e8f0 !important;
}
.v-application.theme--dark .app-header .global-search-field input::placeholder {
  color: #718096;
}

.header-user-block {
  cursor: pointer;
  border-radius: 12px;
  min-width: 0;
  transition: background 0.2s ease;
}
.header-user-block:hover {
  background: rgba(0, 0, 0, 0.04) !important;
}
.v-application.theme--dark .header-user-block:hover {
  background: rgba(255, 255, 255, 0.06) !important;
}
.header-avatar {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.v-application.theme--dark .header-avatar {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.grecaptcha-badge {
  margin-bottom: 50px;
  display: none;
}

.dev-environment-banner {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
}
.dev-environment-banner__text {
  user-select: none;
}

/* White menu styling - Only applies when VUE_APP_WHITE_MENU=true - Force override dark theme */
.v-application .v-navigation-drawer.white-menu-sidebar {
  background-color: white !important;

  .v-list-item,
  .v-list-group__header .v-list-item {
    min-height: 40px !important;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }

  /* Force override all text colors with maximum specificity */
  .v-list,
  .v-list * {
    color: #333333 !important;
  }

  /* Text colors for menu items - maximum specificity */
  .v-list .v-list-item .v-list-item__title,
  .v-list .v-list-item .v-list-item__content,
  .v-list .v-list-group .v-list-group__header .v-list-item__title,
  .v-list .v-list-item .v-list-item__icon .v-icon,
  .v-list .v-list-group .v-list-group__header .v-list-item__icon .v-icon {
    color: #333333 !important;
  }

  /* Item ativo no nível principal (ex.: Dashboard, Provider Documents): fundo + texto */
  .v-list > .v-list-item.v-list-item--active,
  .v-list > .v-list-item.v-list-item--active .v-list-item__title,
  .v-list > .v-list-item.v-list-item--active .v-list-item__content,
  .v-list > .v-list-item.v-list-item--active .v-list-item__icon .v-icon {
    background-color: #dceef0 !important;
    color: #007d82 !important;
  }

  /* Grupos com submenus: sem cor de destaque no cabeçalho (ex.: Search fica igual aos outros) */
  .v-list-group:has(.v-list-item--active) > .v-list-group__header,
  .v-list-group:has(.v-list-item--active) > .v-list-group__header .v-list-item,
  .v-list-group:has(.v-list-item--active) > .v-list-group__header .v-list-item__title,
  .v-list-group:has(.v-list-item--active) > .v-list-group__header .v-icon {
    background-color: transparent !important;
    color: #333333 !important;
  }

  /* Submenus: sem fundo; só a cor do texto no item ativo */
  .v-list .v-list-group .v-list-group__items .v-list-item {
    background-color: transparent !important;
  }
  .v-list .v-list-group .v-list-group__items .v-list-item.v-list-item--active .v-list-item__title {
    color: #007d82 !important;
  }

  /* Hover effects */
  .v-list .v-list-item:hover:not(.v-list-item--active) {
    background-color: rgba(0, 0, 0, 0.04) !important;
  }

  /* Group headers (inativos) */
  .v-list .v-list-group .v-list-group__header .v-list-item__title,
  .v-list .v-list-group .v-list-group__header .v-list-item__icon .v-icon {
    color: #333333 !important;
  }

  /* Sub-items inativos */
  .v-list .v-list-group .v-list-group__items .v-list-item .v-list-item__title {
    color: #666666 !important;
  }

  /* Dividers */
  .v-divider {
    border-color: rgba(0, 0, 0, 0.12) !important;
  }

  /* Force override ALL elements - nuclear option */
  * {
    color: #333333 !important;
  }

  /* Cor única para ativos - especificidade alta (mesmo texto em tudo) */
  .v-list-item--active,
  .v-list-item--active * {
    color: #007d82 !important;
  }

  /* And keep alerts with their original colors */
  .v-alert,
  .v-alert * {
    color: inherit !important;
  }
}

/* Additional global override for white menu when dark theme is active */
.v-application.theme--dark .v-navigation-drawer.white-menu-sidebar {
  background-color: white !important;

  .v-list,
  .v-list *:not(.v-list-item--active):not(.v-alert *) {
    color: #333333 !important;
  }

  .v-list-item--active,
  .v-list-item--active * {
    color: #007d82 !important;
  }
}

.rounded-right {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

@media only screen and (max-width: 959px) {
  .login-sidebar {
    width: 100% !important;
  }

  .selectorColumn {
    min-width: 200px;
  }
}

@media only screen and (min-width: 960px) {
  .admin-menu-option {
    position: fixed !important;
    bottom: 0;
    width: 100%;
  }

  .login-sidebar {
    width: 400px !important;
  }

  .selectorColumn {
    min-width: 200px;
  }
}

/* Global container width overwrite */
@media only screen and (min-width: 1904px) {
  .container {
    max-width: 1500px !important;
  }

  .selectorColumn {
    min-width: 300px;
  }
}

/* Data table styling */
.v-data-table tbody tr.v-data-table__expanded__content {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 25px !important;
}

.v-list-item__icon:last-of-type:not(:only-child) {
  margin-left: 0 !important;
}
.theme--dark.v-tabs-items {
  background-color: #1e1e1e !important;
}

.theme--dark.v-data-table .v-row-group__header td,
.theme--dark.v-data-table .v-row-group__summary td {
  background: rgb(30, 30, 30) !important;
  color: #e2e4e5;
}
.theme--light.v-tabs-items {
  background-color: transparent !important;
}
.flexCard {
  display: flex;
  flex-direction: column;
}
</style>
